import { render } from "./ListeTypeRecette.vue?vue&type=template&id=0df78e91&ts=true"
import script from "./ListeTypeRecette.vue?vue&type=script&lang=ts"
export * from "./ListeTypeRecette.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__